'use strict';
const observable = require('@mindmup/mapjs-core/src/util/observable'),
	_ = require('underscore');
module.exports = function AttachmentEditorController(mapModel, picker, navigatorModel, writerModel, optional) {
	let	currentIdeaId,
		objectUrl;
	const self = observable(this),
		resourceManager = optional && optional.resourceManager,
		source = 'attachment-editor',
		save = function (attachment) {
			if (currentIdeaId) {
				mapModel.setAttachment(source, currentIdeaId, attachment);
				self.dispatchEvent('complete');
			}
		},
		openPicker = function () {
			self.dispatchEvent('picker');
			picker.pickAttachment({notify: () => self.dispatchEvent('uploading')}).then(
				save,
				function (reason) {
					if (reason === 'cancel') {
						self.dispatchEvent('cancel');
					} else if (reason === 'not-subscribed') {
						self.dispatchEvent('cancel');
						self.dispatchEvent('not-subscribed');
					} else {
						self.dispatchEvent('error', reason);
					}
				}
			);
		},
		embeddable = function (contentType) {
			return /^image\//.test(contentType) || /^text\//.test(contentType) || 'application/pdf' === contentType;
		},
		convertibleToNotes = function () {
			return writerModel && writerModel.canImportFromAttachment(currentIdeaId);
		},
		convertToDetails = function (currentAttachment) {
			let result;
			if (!currentAttachment) {
				return false;
			}
			if (currentAttachment.contentType === 'application/vnd.google.drive.attachment') {
				result = _.clone(currentAttachment.content);
			} else {
				result = _.clone(currentAttachment);
			}
			objectUrl = false;
			if (result.dataUriEncoded && result.content) {
				objectUrl = navigatorModel.toObjectUrl(navigatorModel.dataURLToBlob(result.content));
			} else if (result.content && (!result.embedUrl || !result.url)) {
				objectUrl = navigatorModel.toObjectUrl(result.content, result.contentType);
			} else if (resourceManager && result.goldAssetId)  {
				objectUrl = resourceManager.getResource(result.goldAssetId);
			}
			if (objectUrl) {
				result.downloadUrl = objectUrl;
				if (embeddable(result.contentType)) {
					result.embedUrl = objectUrl;
				}
			}
			return result;
		},
		getActions = function (currentAttachment) {
			if (!currentAttachment) {
				return {};
			}
			return {
				open: !!currentAttachment.url,
				'no-preview': !currentAttachment.embedUrl,
				download: !!currentAttachment.downloadUrl,
				convertToNotes: convertibleToNotes()
			};
		},
		openForNode = function (activeIdeaId, attachment) {
			const attachmentDetails =  convertToDetails(attachment);
			currentIdeaId = activeIdeaId;

			if (attachment) {
				self.dispatchEvent('view', attachmentDetails, getActions(attachmentDetails));
			} else {
				openPicker();
			}
		};
	mapModel.addEventListener('attachmentOpened', openForNode);
	self.removeAttachment = function () {
		save();
	};
	self.changeAttachment = function () {
		openPicker();
	};
	self.convertToNotes = function () {
		if (currentIdeaId) {
			if (writerModel.importFromAttachment(currentIdeaId)) {
				self.dispatchEvent('complete');
				writerModel.editNoteForNodeId(currentIdeaId);
			} else {
				self.dispatchEvent('error', 'attachment-conversion');
			}
		}
	};
	self.cleanup = function () {
		if (objectUrl) {
			navigatorModel.revokeObjectUrl(objectUrl);
			objectUrl = false;
		}
	};
};

